import React from "react";

function WelcomePage({ setCurrentStep, eventData, setValues }) {
  const handleRegister = () => {
    setCurrentStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setValues({
      event_id: "",
    });
    setCurrentStep((prevActiveStep) => prevActiveStep - 1);
  };
  return (
    <div className="container">
      <div className="bg-white shadow rounded-lg py-14 text-center mx-5 md:mx-8 lg:mx-0">
        <h1
          className="text-2xl md:text-3xl font-bold mb-4"
          style={{
            color: eventData?.font_color,
          }}
        >
          Welcome to
        </h1>
        <h1
          className="text-3xl md:text-4xl font-bold mb-5 "
          style={{
            color: eventData?.font_color,
          }}
        >
          {eventData?.name}
        </h1>
        <div className="flex justify-center gap-5 py-3">
          <button
            className="border border-blueColor text-blueColor hover:bg-blueColor hover:text-white transition-all duration-300 px-8 py-2 lg:w-48 rounded-lg font-semibold"
            onClick={handleBack}
          >
            Back
          </button>
          <button
            className=" text-white px-6 py-2 lg:w-48 rounded-lg"
            style={{
              backgroundColor: eventData?.btn_color,
            }}
            onClick={handleRegister}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
